import axios from "axios";
import { API_URL } from "configs";
import {
  PAF_GENERATION_SETTINGS_PATHS,
  mapApiSettingToRow,
  mapRowsToBulkPayload,
  normalizeSettingsList,
} from "./constants";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

/**
 * Load all PAF generation settings and map them to UI rows.
 */
export const fetchPafGenerationSettings = async (objectViewedId) => {
  const response = await axios.get(
    `${API_URL}${PAF_GENERATION_SETTINGS_PATHS.list}`,
    {
      headers: authHeaders(),
      params: objectViewedId ? { object_viewed_id: objectViewedId } : undefined,
    }
  );

  return normalizeSettingsList(response.data).map(mapApiSettingToRow);
};

/**
 * Persist all edited rows via the bulk update API.
 */
export const bulkUpdatePafGenerationSettings = async (
  rows,
  objectViewedId
) => {
  const payload = {
    ...mapRowsToBulkPayload(rows),
    ...(objectViewedId ? { object_viewed_id: objectViewedId } : {}),
  };

  const response = await axios.put(
    `${API_URL}${PAF_GENERATION_SETTINGS_PATHS.bulk}`,
    payload,
    { headers: authHeaders() }
  );

  return normalizeSettingsList(response.data).map(mapApiSettingToRow);
};
